import { NgModule } from '@angular/core';
import { AnalyseComponent } from './analyse.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/shared/components.module';
import { routes } from './analyse.routes';
import { AnalyseDashboardComponent } from './dashboard/dashboard.component';
import { DaymaxGraphComponent } from './nettleie/daymaxGraph/daymaxGraph.component';
import { DaymaxTableComponent } from './nettleie/daymaxTable/daymax-table.component';
import { NettleieAnalyseComponent } from './nettleie/nettleie.component';
import { BoxWrapperComponent } from './box-wrapper/box-wrapper.component';
import { SummaryNettleieComponent } from './nettleie/summary/summary.component';
import { PredictionNettleieComponent } from './nettleie/prediction/prediction.component';
import { CustomerFeedbackComponent } from './customer-feedback/customer-feedback/customer-feedback.component';
import { NettleieAdvisoryComponent } from './nettleie/advisory/advisory.component';
import { YourHoursComponent } from './nettleie/yourHours/yourHours.component';
import { ProfileIconComponent } from '../tab-icons/profile.component';

@NgModule({
  declarations: [
    AnalyseComponent,
    DaymaxTableComponent,
    DaymaxGraphComponent,
    NettleieAnalyseComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentsModule,
    BoxWrapperComponent,
    AnalyseDashboardComponent,
    SummaryNettleieComponent,
    PredictionNettleieComponent,
    CustomerFeedbackComponent,
    NettleieAdvisoryComponent,
    YourHoursComponent,
    ProfileIconComponent
  ],
  exports: []
})
export class AnalyseComponentsModule {}
